/**
 * Configuración de la vista de lista "Mesas" (Punto de venta).
 */

import { PointOfSaleIcon } from '@/lib/polaris-icons';
import type { ListViewConfig } from '@/types/listView.types';

export interface TableListItem {
  id: string;
  table_number: string;
  name: string | null;
  capacity: number;
  location: string | null;
  status: 'free' | 'occupied' | 'reserved' | 'maintenance';
  status_label: string;
  status_tone: 'success' | 'critical' | 'attention' | 'subdued';
  qr_display: string;
}

export type NavigateFn = (path: string) => void;

export interface TablesListConfigOptions {
  onBack: () => void;
  onAddTable?: () => void;
}

export function getTablesListConfig(
  onBack: () => void,
  options?: TablesListConfigOptions
): ListViewConfig<TableListItem> {
  const addAction = options?.onAddTable;
  return {
    title: 'Gestión de mesas',
    titleIcon: PointOfSaleIcon,
    onBack,
    backAccessibilityLabel: 'Volver a Punto de venta',
    primaryAction: addAction
      ? { content: 'Nueva mesa', onAction: addAction }
      : undefined,
    resourceName: { singular: 'mesa', plural: 'mesas' },
    columns: [
      { key: 'table_number', title: 'Número', type: 'text', fontWeight: 'medium' },
      { key: 'name', title: 'Nombre', type: 'text' },
      { key: 'capacity', title: 'Capacidad', type: 'number' },
      { key: 'location', title: 'Ubicación', type: 'text', tone: 'subdued' },
      {
        key: 'status_label',
        title: 'Estado',
        type: 'badge',
        toneKey: 'status_tone',
      },
      {
        key: 'qr_display',
        title: 'QR Code',
        type: 'badge',
        format: (v) => (v === 'Generado' ? 'Generado' : 'Sin QR'),
        toneFromValue: (v) => (v === 'Generado' ? 'success' : 'subdued'),
      },
      { key: 'actions', title: 'Acciones', type: 'actions', editLabel: 'Editar', deleteLabel: 'Eliminar', delete: true },
    ],
    emptyState: {
      heading: 'No hay mesas registradas',
      description: 'Crea tu primera mesa para empezar a tomar pedidos en salón.',
      image: 'https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png',
      action: addAction ? { content: 'Nueva mesa', onAction: addAction } : undefined,
    },
    bulkActions: [{ content: 'Exportar datos', actionKey: 'export' }],
    idKey: 'id',
  };
}
